export enum TABS {
  /** 기본정보 */
  BASIC = 'basic',
  /** 기부내역 */
  DONATIONS = 'donations',
  /** 응원하기 */
  COMMENTS = 'comments',
}

export const TABS_LABELS = {
  [TABS.BASIC]: '사업소개',
  [TABS.DONATIONS]: '기부내역',
  [TABS.COMMENTS]: '응원하기',
} as const;
